import i18n from "@/libs/i18n";

export default [
  {
    get header() {
      return i18n.t("common.hospital");
    },
    permission: "get-doctor",
    role: "Hospital",
  },

  {
    get title() {
      return i18n.t("clinic.doctors");
    },
    route: "doctor",
    icon: "PlusCircleIcon",
    permission: "get-doctor",
    role: "Hospital",
  },
  {
    get title() {
      return i18n.t("hospital.services");
    },
    route: "service",
    icon: "RepeatIcon",
    permission: "get-service",
    role: "Hospital",
  },
  {
    get title() {
      return i18n.t("hospital.ServiceTypes");
    },
    route: "service-type",
    icon: "RepeatIcon",
    permission: "get-serviceTypes",
    role: "Hospital",
  },
  {
    get title() {
      return i18n.t("common.avilable-rooms");
    },
    route: "available-rooms",
    permission: "get-room",
    icon: "BookOpenIcon",
    role: "Hospital",
  },
  {
    get title() {
      return i18n.t("clinic.floors");
    },
    route: "floor",
    icon: "CornerRightUpIcon",
    permission: "get-floor",
    role: "Hospital",
  },
  {
    get title() {
      return i18n.t("clinic.Rooms");
    },
    route: "room",
    icon: "BookOpenIcon",
    permission: "get-room",
    role: "Hospital",
  },
  {
    get title() {
      return i18n.t("lab.VitalSignsTypes");
    },
    route: "vital-sign-types",
    permission: "get-vitalSignType",
    icon: "BriefcaseIcon",
    role: "Hospital",
  },

  // {
  //   get title() {
  //     return i18n.t("QuickInvoiceType.title");
  //   },
  //   route: "quick-invoice-type",
  //   permission: "get-quickInvoiceType",
  //   icon: "BriefcaseIcon",
  //   role: "Hospital",
  // },

  // /////////////////////// hospital expenses and income ///////////////////////
  // {
  //   get title() {
  //     return i18n.t("hospital.hospital-expenses");
  //   },
  //   route: "hospital-expenses",
  //   icon: "DollarSignIcon",
  //   permission: "get-hospitalExpense",
  //   role: "Hospital",
  // },
  // {
  //   get title() {
  //     return i18n.t("hospital.hospital-income");
  //   },
  //   route: "hospital-income",
  //   icon: "DollarSignIcon",
  //   permission: "get-hospitalIncome",
  //   role: "Hospital",
  // },
  // {
  //   get title() {
  //     return i18n.t("hospital.hospital-exchange-rate");
  //   },
  //   route: "hospital-exchange-rate",
  //   icon: "ShieldIcon",
  //   permission: "get-hospitalExchangeRate",
  //   role: "Hospital",
  // },
];
